<template>
  <div>
    <div class="banner">
      <a-row type="flex" justify="space-around" align="middle" :gutter="[40, 40]">
        <a-col :span='14'>
          <h1>Future-AI信息科技学生评价系统</h1>
          <h3>Future-AI评价系统为教育主管单位、学校，提供信息科技学生素养和学业水平测评/评价服务</h3>
          <a href="http://demo.aipj.org.cn" target="_blank">
            <span style="margin-top:30px;" class="btn">查看系统演示</span>
          </a>
        </a-col>
        <a-col :span='10'><img src="../assets/banner1.png" alt=""></a-col>
      </a-row>
    </div>
    <div class="section">
      <div class="title">
        <h2>评价系统功能</h2>
        <img src="../assets/divider.png" alt="">
      </div>
      <div class="content">
        <h3 class="subtitle">Future-AI信息科技评价系统集成CMS信息发布、班级管理、题库考试系统、人工智能基础算法与应用领域作品提交、编程赛事提交与在线评审。 支持基于Python和C++等实操测评考试自动判卷等。针对低年级，提供语音读题功能。</h3>
        <div class="wrap1">
          <a-row type="flex" justify="space-around" align="middle" :gutter="[24,24]">
            <a-col :span="6">
              <div class="card1">
                <h3>权限灵活</h3>
                <p>系统能够区分多个校区，并精细的控制每个角色、用户的权限。实现不同的人看不同的数据，不同的人看到不同的按钮。</p>
                <span class="more"><a-icon type="plus-circle" /> 了解更多</span>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="card1">
                <h3>多端适配</h3>
                <p>兼容主流浏览器，适配各种PC设备、平板设备和手机设备。随时随地可以使用本平台。</p>
                <span class="more"><a-icon type="plus-circle" /> 了解更多</span>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="card1">
                <h3>灵活安全</h3>
                <p>系统采用PaaS/SaaS架构，轻松实现定制开发。数据应用独立部署存储，保证数据安全性。</p>
                <span class="more"><a-icon type="plus-circle" /> 了解更多</span>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="card1">
                <h3>教学工具</h3>
                <p>系统默认集成了Scratch、ScratchJr、Python、Turtle、C++、C、Java等编程教学工具。</p>
                <span class="more"><a-icon type="plus-circle" /> 了解更多</span>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="title">
        <h2>解决方案</h2>
        <img src="../assets/divider.png" alt="">
      </div>
      <div class="content">
        <h3 class="subtitle">专注于信息科技学科期末测评、阶段性教学评价、科技特长生选拔，无论你们遇到什么样的问题，我们都可以提供相应的解决方案。</h3>
        <div class="wrap1">
          <a-row :gutter="[24,24]">
                <a-col :span="8">
                    <div class="card2">
                        <img src="../assets/solu1.png" alt="">
                        <h3>专业题库资源</h3>
                        <p>系统提供海量的信息科技（含人工智能学科题库资源），灵活的创建试卷和发起不同班级不同场次考试。我们的运营团队一对一操作指导。</p>
                    </div>
                </a-col>
                <a-col :span="8">
                    <div class="card2">
                      <img src="../assets/solu1.png" alt="">
                        <h3>PssS平台托管</h3>
                        <p>根据您的需求，分为网页版直接使用，无需下载任何用户端软件。也可以为教育局或集团学校部署专属的系统，独立的域名，无忧托管到我们的PaaS平台，数据完全隔离。</p>
                    </div>
                </a-col>
                <a-col :span="8">
                    <div class="card2">
                      <img src="../assets/solu1.png" alt="">
                        <h3>在线智能生成评价报告</h3>
                        <p>持续研发多种教学评价工具，围绕学科核心素养模型评价维度生成区域整体评价报告、学校版教学评价报告和学生个人学习评价报告，帮助教育管理者/教师根据评价数据改进教学方式方法。</p>
                    </div>
                </a-col>
          </a-row>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="title">
        <h2>我们的数据</h2>
        <img src="../assets/divider.png" alt="">
      </div>
      <div class="content">
        <h3 class="subtitle">FutureAI信息科技评价系统集成CMS信息发布、班级管理、题库考试系统、人工智能基础算法与应用领域作品提交、编程赛事提交与在线评审。 支持基于Python和C++等实操测评考试自动判卷等。针对低年级，提供语音读题功能。</h3>
        <div class="wrap1">
          <img src="../assets/datacount.png" alt="">
        </div>
      </div>
    </div>
    <div class="section">
      <div class="title">
        <h2>部分服务单位</h2>
        <img src="../assets/divider.png" alt="">
      </div>
      <div class="content">
        <h3 class="subtitle">我们为以下机构和单位提供了系统开发、技术合作等服务。</h3>
        <div class="wrap1">
            <a-row :gutter="[16,16]">
                <a-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                    <img src="../assets/c1.png" alt="">
                </a-col>
                <a-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                    <img src="../assets/c2.png" alt="">
                </a-col>
                <a-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                    <img src="../assets/c3.png" alt="">
                </a-col>
                <a-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
                    <img src="../assets/c4.png" alt="">
                </a-col>
            </a-row>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="title">
        <h2>服务案例</h2>
        <img src="../assets/divider.png" alt="">
      </div>
      <div class="content">
        <h3 class="subtitle">因为专业、专注信息科技学科领域，所以获得他们的认可。</h3>
        <div class="wrap1">
          <a-row :gutter="[16,16]">
              <a-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                  <img src="../assets/case1.png" alt="">
              </a-col>
              <a-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                  <img src="../assets/case2.png" alt="">
              </a-col>
              <a-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                  <img src="../assets/case3.png" alt="">
              </a-col>
            </a-row>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="title">
        <h2>北京未来基因教育科技有限公司</h2>
        <img src="../assets/divider.png" alt="">
      </div>
      <div class="content">
        <h3 class="subtitle">该系统具备人工智能核心素养模型和信息科技学生素养模型将准确测出学生的知识储备、特长发展、学习行为、学习漏洞等多方面的情况做出综合评价，为信息科技课堂教学和区域科技教育发展提供科学依据。</h3>
        <div class="wrap1">
          <a-row type="flex" justify="space-around" align="middle" :gutter="[16,16]">
              <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <img src="../assets/cert.png" style="width:100%" alt="">
              </a-col>
              <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <div class="com-desc">
                  <p>北京未来基因教合科技有限公司成立于 2017 年，总部设在北京。下设未来基因（北京）人工智能研究院。</p>
                  <p>未来基因，作为中国人工智能学会中小学工作委员会和中国自动化学会普及工作委员会副主任单位，正在不断为中国中小学人工智能教育的落地提供技术支撑和产业融合。</p>
                  <p>该系统是在综合中国自动化学会人工智能核心素养测评相关研究成果的基础上，整合国科大人工智能学院、清华大学、中国人民大学等的专家学术资源和未来基因(北京)人工智能研究院研发技术打造的一套针对中小学的人工智能、信息科技学科教育个性化教学测评系统。</p>
                </div>
                  <a href="https://weilaijiyin.com/" target="_blank"><span class="btn">前往官网</span></a>
              </a-col>
            </a-row>
        </div>
      </div>
    </div>
    <div class="section">
      <a-row type="flex" justify="space-around" align="middle">
        <a-col :span="18">
          <div class="title">
            <h2>想要进一步沟通？</h2>
            <img src="../assets/divider.png" alt="">
          </div>
          <div class="content">
            <div class="wrap1">
              <br><br>
              <p>期待与您的进一步交流讨论，欢迎扫码添加微信！</p>
            </div>
          </div>
        </a-col>
        <a-col :span="6"><img src="../assets/wxqrcode.png" alt=""></a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.btn{
  display: inline-block;
  background:linear-gradient(180deg, rgb(250,194,44), rgb(255,101,73));
  border-radius:5px;
  padding:10px 20px;
  color:white;
  font-size: 16px;
  cursor: pointer;
}
.banner{

}
.section{
  padding-top: 40px;
  .title{
    text-align: center;
    h2{
      font-size: 30px;
      font-weight: 600;
      margin-bottom: 20px;
    }
    img{
      width: 150px;
    }
  }
  .content{
    .subtitle{
      margin: 20px auto;
      display: block;
      max-width: 600px;
      text-align: center;
    }

    .wrap1{
      text-align: center;
      .card1{
        margin: 0 auto;
        padding: 20px 20px;
        text-align: center;
        border-radius: 5px;
        min-height: 200px;
        border: solid 2px rgb(255,231,227);
        background: linear-gradient(180deg, rgb(253,242,214), rgb(255,224,219));
      }

    .card2{
        margin: 0 auto;
        padding: 20px 20px;
        text-align: center;
        border-radius: 5px;
        min-height: 200px;
        background: #fff;
        // border: solid 2px rgb(255,231,227);
        // background: linear-gradient(180deg, rgb(253,242,214), rgb(255,224,219));
      }

      h3{
        font-weight: 700;
        margin-bottom: 20xp;
      }
      p{

      }
      .more{
        cursor: pointer;
        font-weight: 700;
        margin-top: 20px;
      }
      .com-desc{
        p{
            text-indent:2em;
            text-align: left;
            font-family: '微软雅黑';
        }
      }
    }
  }
}
</style>>

</style>